import { onBeforeUnmount, Ref } from '@vue/composition-api';

export function useOutListener(
    root: Ref<HTMLElement | null>,
    onHide: Function,
) {
    function handleClick(e: MouseEvent) {
        if (!root.value) {
            return;
        }

        // @ts-ignore
        if (!root.value.contains(e.target)) {
            onHide();
        }
    }

    document.body.addEventListener('click', handleClick);

    onBeforeUnmount(() => {
        document.body.removeEventListener('click', handleClick);
    });
}
